/**
 * Shared Provider Utilities & Metadata
 * Centralizes telecom provider branding, badges, initials, and logos.
 */

export interface ProviderMeta {
  cls: string;
  label: string;
  icon: string;
}

/**
 * Get provider styling class based on telecom operator name
 */
export const getLogoClass = (name: string, logoClass?: string): string => {
  if (logoClass && logoClass !== 'default') return logoClass;
  const n = (name || '').toLowerCase();
  if (n.includes('telkom') || n.includes('tsel')) return 'telkomsel';
  if (n.includes('indo') || n.includes('isat') || n.includes('im3')) return 'indosat';
  if (n.includes('xl') || n.includes('axis')) return 'xl';
  if (n.includes('tri') || n.includes('3')) return 'tri';
  if (n.includes('pstn') || n.includes('rumah')) return 'pstn';
  if (n.includes('smart') || n.includes('fren')) return 'smartfren';
  if (n.includes('sip') || n.includes('trunk')) return 'siptrunk';
  return 'default';
};

/**
 * Get full metadata (class, short label, icon emoji) for a telecom provider
 */
export const getProviderMeta = (name?: string): ProviderMeta => {
  const n = (name || '').toLowerCase();
  if (n.includes('telkom') || n.includes('tsel')) {
    return { cls: 'telkomsel', label: 'TSEL', icon: '📶' };
  }
  if (n.includes('indo') || n.includes('isat') || n.includes('im3')) {
    return { cls: 'indosat', label: 'ISAT', icon: '🟡' };
  }
  if (n.includes('xl') || n.includes('axis')) {
    return { cls: 'xl', label: 'XL', icon: '🔵' };
  }
  if (n.includes('tri') || n.includes('3')) {
    return { cls: 'tri', label: 'TRI', icon: '🟣' };
  }
  if (n.includes('smart') || n.includes('fren')) {
    return { cls: 'smartfren', label: 'FREN', icon: '🔴' };
  }
  if (n.includes('pstn') || n.includes('rumah')) {
    return { cls: 'pstn', label: 'PSTN', icon: '☎️' };
  }
  if (n.includes('sip') || n.includes('trunk')) {
    return { cls: 'siptrunk', label: 'SIP', icon: '🌐' };
  }
  return {
    cls: 'default',
    label: (name || 'UN').substring(0, 3).toUpperCase(),
    icon: '📡',
  };
};
